import React from 'react';
import { FormText } from 'reactstrap';
import { connect } from 'react-redux';

const ErrorBar = ({ errors, fieldName, fieldText }) => (
  <div>
    {errors[fieldName] && <FormText color='danger'>{errors[fieldName]}</FormText>}
    {!errors[fieldName] && <FormText color='muted'>{fieldText}</FormText>}
  </div>
);

export default connect((state) => ({
  errors: state.entities.alerts.errors
}))(ErrorBar);
